var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVscodeIconsFileTypeExcel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6865 11.5123L6.38477 10.0498V20.8566C6.38467 20.974 6.40775 21.0903 6.4527 21.1989C6.49765 21.3074 6.56358 21.4059 6.6467 21.4889C6.72983 21.5719 6.82851 21.6377 6.93711 21.6824C7.0457 21.7272 7.16206 21.7501 7.27952 21.7498H21.6045C21.7221 21.7503 21.8386 21.7276 21.9474 21.6829C22.0562 21.6382 22.155 21.5725 22.2383 21.4895C22.3216 21.4065 22.3876 21.3078 22.4327 21.1992C22.4777 21.0906 22.5009 20.9741 22.5008 20.8566V16.8748L14.6865 11.5123Z",
    fill: "#185C37"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6865 2.25H7.27952C7.16206 2.24971 7.0457 2.2726 6.93711 2.31736C6.82851 2.36213 6.72983 2.42789 6.6467 2.51088C6.56358 2.59386 6.49765 2.69244 6.4527 2.80096C6.40775 2.90947 6.38467 3.0258 6.38477 3.14325V7.125L14.6865 12L19.0823 13.4625L22.5008 12V7.125L14.6865 2.25Z",
    fill: "#21A366"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.38477 7.125H14.6865V12H6.38477V7.125Z",
    fill: "#107C41"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M12.3263 6.1499H6.38477V18.3374H12.3263C12.563 18.3362 12.7898 18.2418 12.9574 18.0746C13.125 17.9074 13.22 17.6809 13.2218 17.4442V7.04315C13.22 6.80641 13.125 6.57989 12.9574 6.4127C12.7898 6.2455 12.563 6.15108 12.3263 6.1499Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M11.838 6.6377H6.38477V18.8252H11.838C12.0748 18.824 12.3015 18.7296 12.4691 18.5624C12.6368 18.3952 12.7317 18.1687 12.7335 17.9319V7.53095C12.7317 7.2942 12.6368 7.06769 12.4691 6.90049C12.3015 6.73329 12.0748 6.63887 11.838 6.6377Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M11.838 6.6377H6.38477V17.8502H11.838C12.0748 17.849 12.3015 17.7546 12.4691 17.5874C12.6368 17.4202 12.7317 17.1937 12.7335 16.9569V7.53095C12.7317 7.2942 12.6368 7.06769 12.4691 6.90049C12.3015 6.73329 12.0748 6.63887 11.838 6.6377Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M11.3498 6.6377H6.38477V17.8502H11.3498C11.5865 17.849 11.8133 17.7546 11.9809 17.5874C12.1485 17.4202 12.2435 17.1937 12.2453 16.9569V7.53095C12.2435 7.2942 12.1485 7.06769 11.9809 6.90049C11.8133 6.73329 11.5865 6.63887 11.3498 6.6377Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2.3955 6.6377H11.349C11.5862 6.6375 11.8137 6.73148 11.9816 6.89897C12.1496 7.06647 12.2441 7.29378 12.2445 7.53095V16.4695C12.2441 16.7066 12.1496 16.9339 11.9816 17.1014C11.8137 17.2689 11.5862 17.3629 11.349 17.3627H2.3955C2.27798 17.3631 2.16154 17.3403 2.05286 17.2956C1.94418 17.2508 1.84541 17.1851 1.7622 17.1021C1.679 17.0191 1.613 16.9205 1.56801 16.8119C1.52301 16.7034 1.4999 16.587 1.5 16.4695V7.53095C1.4999 7.41343 1.52301 7.29705 1.56801 7.18848C1.613 7.07991 1.679 6.9813 1.7622 6.89831C1.84541 6.81531 1.94418 6.74957 2.05286 6.70485C2.16154 6.66012 2.27798 6.63731 2.3955 6.6377Z",
    fill: "url(#paint0_linear_94_5127)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M4.27539 14.9047L6.15864 11.9917L4.43364 9.09521H5.81889L6.76014 10.95C6.84714 11.1255 6.91014 11.256 6.93864 11.343H6.95139C7.01289 11.2025 7.07789 11.066 7.14639 10.9335L8.15289 9.09821H9.42789L7.65864 11.9782L9.47289 14.907H8.11614L7.02864 12.8737C6.97829 12.7862 6.93539 12.6946 6.90039 12.6H6.88239C6.85061 12.6922 6.80833 12.7806 6.75639 12.8632L5.63664 14.9047H4.27539Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6043 2.25001H14.6855V7.125H22.4998V3.14325C22.4999 3.02573 22.4768 2.90935 22.4318 2.80079C22.3868 2.69222 22.3208 2.59361 22.2376 2.51061C22.1544 2.42762 22.0556 2.36187 21.9469 2.31715C21.8383 2.27243 21.7218 2.24961 21.6043 2.25001Z",
    fill: "#33C481"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6855 12H22.4998V16.875H14.6855V12Z",
    fill: "#107C41"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_94_5127",
    x1: 3.3705,
    y1: 5.9357,
    x2: 10.374,
    y2: 18.0647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18884F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#117E43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B6631"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVscodeIconsFileTypeExcel);
export default __webpack_public_path__ + "static/media/vscode-icons_file-type-excel.8c6b92fec878283b81e3fb532bf2cdcb.svg";
export { ForwardRef as ReactComponent };